<template>
  <section>
    <div class="categories" v-if="filter_mode && statementCategories">
      <router-link
        :to="{name:'statement',params: { statementType: category.replace(/\s/g, '') }}"
        class="categories__item categories__item--active"
        v-for="category in statementCategories"
        :key="statementCategories[category]"
      >{{category}}</router-link>
    </div>
    <router-view />
  </section>
</template>
<style lang="scss" scoped>
.categories {
  display: flex;
  overflow-x: auto;
  padding-left: 21px;
  background: #fff;
  margin: 20px auto;
  &__item {
    padding: 5px 18px;
    margin-right: 15px;
    font-size: 16px;
    letter-spacing: 0.34px;
    color: #4d4d4d;
    white-space: nowrap;
    outline: none;
    &.router-link-active {
      color: #ffffff;
      border-bottom: 2px solid #3482fd;
      background-color: #3482fd;
      border-radius: 20px;
    }
  }
}
</style>
<script>
import { mapGetters } from "vuex";
import OfferItem from "./OfferItem/index";
export default {
  name: "EplStatementFilter",
  data() {
    return {
      query: {},
      filter_mode: false
    };
  },
  components: { OfferItem },
  computed: {
    ...mapGetters(["loggedIn", "statementCategories"])
  },
  created() {
    this.$store.dispatch("getStatement");
  }
};
</script>



// WEBPACK FOOTER //
// src/components/EplNewStatementFilter.vue